import { Link, useParams } from "react-router-dom";
import {
  getServiceBySlug,
  loadStoredBrandConfig,
} from "../config/brand.js";
import NotFoundPage from "./NotFoundPage.jsx";

export default function ServiceDetailPage() {
  const { slug } = useParams();
  const config = loadStoredBrandConfig();
  const card = getServiceBySlug(slug, config);

  if (!card) {
    return <NotFoundPage />;
  }

  const detail = card.detail || {};
  const summary = detail.summary || card.body;
  const bullets = detail.bullets || [];

  return (
    <article className="site-page">
      <div className="site-page__inner">
        <p className="site-page__eyebrow">{card.kicker}</p>
        <h1 className="site-page__title">{card.title}</h1>
        <p className="site-page__lead">{summary}</p>
        {bullets.length > 0 ? (
          <ul className="site-page__list">
            {bullets.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : null}
        <p className="site-page__muted">
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </article>
  );
}
